import InfoItem from "components/common/detailsPage/InfoItem";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import HorizontalScroller from "components/common/HorizontalScroller";
import PageHeader from "components/common/PageHeader";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPosTransactionDetails } from "store/slices/posTransactionsSlice";
import { CurrencySymbol } from "utils/utils";
import { SquareArrowUpRightIcon } from "lucide-react";
import { Link } from "react-router-dom";

const POSTransactionDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");
  const { canAction } = usePermission();
  const { canView } = canAction("report");
  const { loading, itemDetails } = useSelector(
    (state) => state.PosTransactions,
  );

  const { transaction, customer,invoice} = itemDetails || {};


  useEffect(() => {
    if (id && canView) dispatch(getPosTransactionDetails(id));
  }, [id, canView, dispatch]);

  const transactionFields = [
    {
      label: t("Transaction Id"),
      render: (
        <HorizontalScroller t={t}>
          <div className="value">{transaction?._id || "-"}</div>
        </HorizontalScroller>
      ),
      col: { lg: 6 },
    },
    {
      label: t("Plan Type"),
      value: transaction?.planType || "-",
      col: { lg: 6 },
    },
    {
      label: t("Amount"),
      render:
        transaction?.amount > 0 ? (
          <>
            <p className="price_symbol">
              <CurrencySymbol width="12" height="14" />
              {transaction?.amount}
            </p>
          </>
        ) : (
          "-"
        ),
      col: { lg: 6 },
    },
    {
      label: t("Invoice URL"),
      render: (
        <div>
          {invoice?.pdfUrl?.trim() ? (
            <div className="d-flex align-items-center gap-2 google_map_link_wrapper">
              <Link
                title={t("Go to google map")}
                to={invoice?.pdfUrl || "#"}
                target="_blank"
                className="d-flex align-items-center gap-2"
              >
                <span>{invoice?.pdfUrl || "-"}</span>
                <SquareArrowUpRightIcon width={24} height={24} color="#53c3eb" />
              </Link>
             
            </div>
          ) : (
            "-"
          )}
        </div>
      ),
      col: { lg: 12 },
    },
  ];

  const customerFields = [
    {
      label: t("User Id"),
      render: (
        <HorizontalScroller t={t}>
          <div className="value">{customer?.userId?._id || "-"}</div>
        </HorizontalScroller>
      ),
      col: { lg: 6 },
    },
    {
      label: t("Name"),
      value: customer?.userId?.name || "-",
      col: { lg: 6 },
    },
    {
      label: t("Phone"),
      value: customer?.userId?.phone || "-",
      col: { lg: 6 },
    },
    {
      label: t("Walk-In"),
      value: customer?.isWalkIn ? t("Yes") : t("No"),
      col: { lg: 6 },
    },
  ];

  const shimmerLayout = [
    { col: 6, blocks: [{ rows: 2, cols: 2 }] },
    { col: 6, blocks: [{ rows: 2, cols: 2 }] },
  ];

  if (!canView) return null;

  if (loading || !itemDetails) {
    return (
      <div className="page-content">
        <PageHeader
          title={t("POS Transaction Details")}
          isBackBtn
          className="details_page_title"
        />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page pos_transaction_details_page">
      <PageHeader
        title={t("POS Transaction Details")}
        isBackBtn
        className="details_page_title"
      />

      <Row>
        <Col lg={6}>
          <div className="common_card" style={{ height: "calc(100% - 20px)" }}>
            <Row id="general_detail_row">
              <Col lg={12} className="mb-3 details_heading">
                <h4>{t("Transaction")}</h4>
              </Col>

              {transactionFields.map((item, index) => (
                <InfoItem
                  key={index}
                  label={item.label}
                  value={item.value}
                  col={item.col}
                >
                  {item.render}
                </InfoItem>
              ))}
            </Row>
          </div>
        </Col>

        <Col lg={6}>
          <div className="common_card" style={{ height: "calc(100% - 20px)" }}>
            <Row id="general_detail_row">
              <Col lg={12} className="mb-3 details_heading">
                <h4>{t("Customer")}</h4>
              </Col>

              {customerFields.map((item, index) => (
                <InfoItem
                  key={index}
                  label={item.label}
                  value={item.value}
                  col={item.col}
                >
                  {item.render}
                </InfoItem>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default POSTransactionDetails;
